exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "table[data-v-38c3b6df] {\n  border: 1px solid #e7e7e7;\n  margin: 0 -1px 24px 0;\n  text-align: left;\n  width: 100%;\n}\ntable td[data-v-38c3b6df] {\n  border-top: 1px solid #e7e7e7;\n  padding: 6px 10px;\n}\n", ""]);
